import { useSelector } from 'react-redux';
import { isAppAuthSelector } from '../../../selectors/AuthSelectors';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const EnvironmentWrapper = ({
  authedNode = null,
  publicNode = null
}) => {
  const isAppAuth = useSelector(isAppAuthSelector);
  return isAppAuth ? /*#__PURE__*/_jsx(_Fragment, {
    children: authedNode
  }) : /*#__PURE__*/_jsx(_Fragment, {
    children: publicNode
  });
};
export default EnvironmentWrapper;